export default "__VITE_ASSET__BxrFnNSj__"